export class ColorService {

//#########################################################################
//
// This service is used to keep track of all information about colors.
// We keep track of the following thing and provide an interface to access
// those information from a component:
//      - color as RGB value
//      - color as number
//      - color as name
//      
// Internally we work with RGB only and convert names and numbers to RGB
// first. For this we have hashtables which correlate names and numbers
// (as key) to the corresponding RGB values.
//
// This service proides access to all colors to components, which are interested
// in using colors.
//
//#########################################################################

    private colorRGB: number[];
    private number2rgb = new Array();
    private name2rgb = new Array();

    constructor(arg: any) {
        this.populateNum2RGB();
        this.populateString2RGB();
        var regex = /rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/;
        
        if (typeof (arg) === "number") {
            this.numberConstructor(<number>arg);
        } else if (typeof (arg) === "string" && (<string>arg).match(regex)) {
            var temp = (<string>arg).replace("rgb(", "");
            temp = temp.replace(")", "");
            var values = temp.split(",");
            this.colorRGB = [parseInt(values[0]), parseInt(values[1]), parseInt(values[2])];
        } else if (typeof (arg) === "string") {
            this.stringConstructor(<string>arg);
        } else if (typeof (arg) === "object") {
            //it is a ColorSerice already
            this.colorRGB = arg.colorRGB;
        } else {
            //None of the above apply. Could handle it as an error, or be liberal and change the color to black
            this.colorRGB = [0, 0, 0];
        }
    }

    private numberConstructor(colorNumber: number) {
        this.colorRGB = this.number2rgb[colorNumber];
    }

    private stringConstructor(colorString: string) {
        this.colorRGB = this.name2rgb[colorString];
    }

    private populateNum2RGB() {
        this.number2rgb[0] = [0, 0, 0];
        this.number2rgb[1] = [255, 0, 0];
        this.number2rgb[2] = [0, 255, 0];
        this.number2rgb[3] = [255, 255, 0];
        this.number2rgb[4] = [0, 0, 255];
        this.number2rgb[5] = [255, 0, 255];
        this.number2rgb[6] = [0, 255, 255];
        this.number2rgb[7] = [255, 255, 255];
        this.number2rgb[8] = [128, 128, 128];
        this.number2rgb[9] = [192, 192, 192];
        this.number2rgb[10] = [128, 0, 0];
        this.number2rgb[11] = [0, 128, 0];
        this.number2rgb[12] = [0, 0, 128];
        this.number2rgb[13] = [255, 200, 0];
        this.number2rgb[14] = [255, 175, 175];
        this.number2rgb[15] = [128, 0, 255];
        this.number2rgb[16] = [153, 102, 0];
    }

    private populateString2RGB() {
        this.name2rgb['black'] = [0, 0, 0];
        this.name2rgb['red'] = [255, 0, 0];
        this.name2rgb['green'] = [0, 255, 0];
        this.name2rgb['yellow'] = [255, 255, 0];
        this.name2rgb['blue'] = [0, 0, 255];
        this.name2rgb['magenta'] = [255, 0, 255];
        this.name2rgb['cyan'] = [0, 255, 255];
        this.name2rgb['white'] = [255, 255, 255];
        this.name2rgb['gray'] = [128, 128, 128];
        this.name2rgb['lightgray'] = [192, 192, 192];
        this.name2rgb['darkred'] = [128, 0, 0];
        this.name2rgb['darkgreen'] = [0, 128, 0];
        this.name2rgb['darkblue'] = [0, 0, 128];
        this.name2rgb['orange'] = [255, 200, 0];
        this.name2rgb['pink'] = [255, 175, 175];
        this.name2rgb['purple'] = [128, 0, 255];
        this.name2rgb['brown'] = [153, 102, 0];
    }

    getColorString(): string {
        return 'rgb(' + this.colorRGB[0] + ',' + this.colorRGB[1] + ',' + this.colorRGB[2] + ')';
    }

    getColorRGB(): number[] {
      return this.colorRGB;
    }

    getBlack(): string {
        this.colorRGB = [0, 0, 0];
        return this.getColorString();
    }

    getWhite(): string {
        this.colorRGB = [255, 255, 255];
        return this.getColorString();
    }

    isSameAsColor(other: ColorService): boolean{
	return ColorService.areSameRGB(this.colorRGB, other.colorRGB);
    }

    static areSameRGB(rgb1: number[], rgb2: number[]): boolean {
	return rgb1[0] === rgb2[0]
	    && rgb1[1] === rgb2[1]
	    && rgb1[2] === rgb2[2]
    }


}



// WEBPACK FOOTER //
// ./src/app/services/color.service.ts